<template>
  <b-card header-tag="header">
    <h3 slot="header">Student Volunteer Application</h3>
    <h3 v-if="isLoading">Getting your application...</h3>
    <div class="card-text" v-if="isLoaded">
      <h5 v-if="isNewApp && !profileIncomplete && !completed">Welcome! Let's get started.</h5>
      <h5 v-if="isNewApp && profileIncomplete">Welcome! Fill out your profile so we can start your application</h5>
      <div v-if="completed" class="row">
        <div class="col">
          <h2 class="mb-2">Thank You For Applying!</h2>
          <p>You have successfully applied to the SIGGRAPH Student Volunteer Program.</p>
          <p>To ensure accurate registration, make sure <router-link to="/profile">your profile</router-link> is kept up
            to date.</p>
          <h3>Notification of Acceptance</h3>
          <p>The first group of accepted applicants will notified in early May 2026. In order to recieve your results as
            soon as possible, please take a moment now to adjust your spam filter settings to ensure emails from the
            ‘siggraph.org’ domain are not sent to your junk folder.</p>
        </div>
      </div>
      <div v-else>
        <h5 v-if="isNotNewApp">Application in Progress</h5>
        <div class="row">
          <div class="col">
            <b-progress v-if="isNotNewApp" height="2rem" class="mb-2">
              <b-progress-bar :value="getProgress" :label="`${getProgress}%`"></b-progress-bar>
            </b-progress>
            <button v-if="isNotNewApp" type="button" @click="goToApp" class="btn arrow-btn-primary">
              <div>Continue Application</div>
            </button>
            <button v-if="isNewApp && !profileIncomplete" type="button" @click="goToApp"
              class="btn arrow-btn-primary btn-lg">
              <div>Start Application</div>
            </button>
            <button v-if="isNewApp && profileIncomplete" type="button" @click="goToProfile"
              class="btn arrow-btn-primary">
              <div>Update Profile</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import router from '@/router'

  export default {
    name: 'SvLiveAppStatus',
    data () {
      return {
        appBtnDisabled: false
      }
    },
    computed: {
      ...mapGetters('application', ['getProgress', 'isNewApp', 'isNotNewApp']),
      ...mapGetters('user', ['profileIncomplete']),
      ...mapState('application', ['isLoaded', 'isLoading', 'completed', 'teamLeader'])
    },
    methods: {
      goToApp (e) {
        e.preventDefault()
        router.push('/application/1')
      },
      goToProfile (e) {
        e.preventDefault()
        router.push('/profile')
      }
    },
    created: function () {
      if (!this.$store.state.application.isLoaded) {
        this.$store.dispatch('application/load')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/LiveAppStatus.vue